<mat-divider></mat-divider>

<mat-list>
  <div mat-subheader>Pending invitations</div>
  <mat-list-item *ngFor="let invitation of invitations; trackBy: trackByUid">
    <div class="align">
      <mat-icon mat-list-icon>{{ getIcon(invitation) }}</mat-icon>
      <div class="name">
        <div mat-line>{{ getTarget(invitation) }}</div>
        <div mat-line>{{ invitation.createdAt / 1000 | amFromUnix | amTimeAgo }}</div>
      </div>
      <button *ngIf="canRemoveInvitations" mat-icon-button [matMenuTriggerFor]="invitationsMenu">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #invitationsMenu="matMenu">
        <button mat-menu-item (click)="copyInvitationLink(invitation)">
          <mat-icon>content_copy</mat-icon>
          Copy invitation link
        </button>

        <button mat-menu-item (click)="removePendingInvitationClicked(invitation)" style="color: red">
          <mat-icon>delete</mat-icon>
          Remove invitation
        </button>
      </mat-menu>
    </div>
  </mat-list-item>
</mat-list>
